module.exports = __webpack_public_path__ + "static/media/wedc.5a38bb38.jpg";